import { render, staticRenderFns } from "./formBranch.vue?vue&type=template&id=161fea33&"
import script from "./formBranch.vue?vue&type=script&lang=js&"
export * from "./formBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports